// LEGAL STATUS: To be legally validated before commercial production (EN translation of fr/DpaPage.js).
import { Link } from "react-router-dom";
import { FileSignature } from "lucide-react";
import { Button } from "../../ui/button";
import { Page, H1, H2, Lead, P, Notice, DocVersion } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const DpaPage = () => (
  <Page testid="dpa-page">
    <H1>Data processing agreement (DPA)</H1>
    <Lead>
      This page presents the topics covered by a data processing agreement between the customer
      and {legal.publisherName}. Version <DocVersion value={legal.dpaVersion} />.
    </Lead>

    <Notice testid="dpa-work-note">
      This is not a legally signed DPA: it is a presentation of the topics. The final contractual
      document will be provided on request before commercial production.
    </Notice>

    <H2 id="objet">Purpose</H2>
    <P>Govern the processing of personal data carried out by SecurePass on behalf of the customer.</P>

    <H2 id="instructions">Customer instructions</H2>
    <P>Processing is carried out according to the customer's documented instructions.</P>

    <H2 id="confidentialite">Confidentiality</H2>
    <P>Persons authorised to process the data are bound by a confidentiality obligation.</P>

    <H2 id="securite">Security</H2>
    <P>
      Technical and organisational measures: browser-side encryption, key kept separate from the content,
      one-time read, expiration, HTTP hardening (see the
      <Link to="/securite" className="text-emerald-600 underline"> Security</Link> page).
    </P>

    <H2 id="sous-traitants">Subprocessors</H2>
    <P>
      The use of further subprocessors is regulated. The current list is available on the
      <Link to="/sous-traitants" className="text-emerald-600 underline"> Subprocessors</Link> page.
    </P>

    <H2 id="assistance">Assistance</H2>
    <P>Reasonable assistance to the customer in responding to requests from data subjects.</P>

    <H2 id="incidents">Incidents</H2>
    <P>Notification of personal data breaches under the conditions set out by the regulations.</P>

    <H2 id="suppression">Deletion / return</H2>
    <P>Deletion or return of the data at the end of the service, at the customer's choice.</P>

    <H2 id="audit">Audit</H2>
    <P>Provision of the information necessary to demonstrate compliance.</P>

    <H2 id="localisation">Location and transfers</H2>
    <P>
      Information about the hosting location and any transfers will be specified once the hosting
      provider is confirmed (see Legal notice).
    </P>

    <div className="mt-8">
      <Link to="/contact?subject=dpa">
        <Button data-testid="dpa-request-btn" className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold">
          <FileSignature className="w-4 h-4 mr-2" /> Request the DPA
        </Button>
      </Link>
    </div>
  </Page>
);

export default DpaPage;
